import React from 'react';
import { Modal } from 'antd';
import UserForm from './UserForm';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';

export default function AddUser() {
    const general = useGeneralStore();
    const visible = general.view.userAddModal;

    return (
        <Modal
            width={800}
            className="custom-table"
            title="افزودن کاربر"
            visible={visible}
            footer={false}
            onCancel={() => general.ToggleUserAddModal()}>
            <UserForm
                onSubmit={() => {
                    general.ToggleUserAddModal();
                    general.NotifSuccess('کاربر جدید با موفقیت ثبت شد');
                }}
                formType={false}
            />
        </Modal>
    )
}
